export type ProductFilter = { name: string };
export interface SupportFilterBarFormState {
  product: string;
  search: string;
}

export enum SupportView {
  CATEGORY = 'CATEGORY',
  TOPIC = 'TOPIC',
  SEARCH = 'SEARCH'
}
